export default function Privacypolicycontent() {
  return <section data-section-id="259350" id="privacypolicycontent" className="py-12 bg-background text-foreground">
      <div className="container mx-auto px-4 max-w-3xl">
        <div className="mb-12 p-6 bg-card rounded-lg border border-border shadow-md">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground mb-4 font-default">
            Contact Information
          </h2>
          <div className="space-y-2 text-muted-foreground font-default">
            <p><span className="font-semibold text-foreground">Address:</span> 1121 Broad Street Suite 1 #1008 Sumter SC 29150</p>
            <p><span className="font-semibold text-foreground">Email:</span> hello@blinklabmedia.com</p>
            <p><span className="font-semibold text-foreground">Phone:</span> 803-470-4042</p>
            <p><span className="font-semibold text-foreground">Website:</span> www.blinklabmedia.com</p>
          </div>
        </div>

        <div className="flex flex-col gap-10">
          <div className="border-l-[3px] border-secondary pl-6">
            <h3 className="text-xl font-bold text-foreground mb-3 font-default">
              1. Information We Collect
            </h3>
            <p className="text-muted-foreground leading-7 font-default">
              We collect information you provide directly to us, such as when you create an account, subscribe to our newsletter, or contact us for support. This may include your name, email address, and payment information.
            </p>
          </div>

          <hr className="border-border" />

          <div className="border-l-[3px] border-secondary pl-6">
            <h3 className="text-xl font-bold text-foreground mb-3 font-default">
              2. How We Use Your Information
            </h3>
            <p className="text-muted-foreground leading-7 font-default">
              We use the information we collect to provide, maintain, and improve our services, to process transactions, and to communicate with you about products, services, and events.
            </p>
          </div>

          <hr className="border-border" />

          <div className="border-l-[3px] border-secondary pl-6">
            <h3 className="text-xl font-bold text-foreground mb-3 font-default">
              3. Information Sharing
            </h3>
            <p className="text-muted-foreground leading-7 font-default">
              We do not share your personal information with third parties except as described in this policy, such as with your consent or to comply with legal obligations.
            </p>
          </div>

          <hr className="border-border" />

          <div className="border-l-[3px] border-secondary pl-6">
            <h3 className="text-xl font-bold text-foreground mb-3 font-default">
              4. Data Security
            </h3>
            <p className="text-muted-foreground leading-7 font-default">
              We take reasonable measures to help protect information about you from loss, theft, misuse, and unauthorized access, disclosure, alteration, and destruction.
            </p>
          </div>

          <hr className="border-border" />

          <div className="border-l-[3px] border-secondary pl-6">
            <h3 className="text-xl font-bold text-foreground mb-3 font-default">
              5. Cookies and Tracking
            </h3>
            <p className="text-muted-foreground leading-7 font-default">
              We use cookies and similar tracking technologies to track activity on our service and hold certain information to improve and analyze our service.
            </p>
          </div>

          <hr className="border-border" />

          <div className="border-l-[3px] border-secondary pl-6">
            <h3 className="text-xl font-bold text-foreground mb-3 font-default">
              6. Your Privacy Rights
            </h3>
            <p className="text-muted-foreground leading-7 font-default">
              Depending on your location, you may have certain rights regarding your personal data, including the right to access, correct, or delete the information we hold about you.
            </p>
          </div>

          <hr className="border-border" />

          <div className="border-l-[3px] border-secondary pl-6">
            <h3 className="text-xl font-bold text-foreground mb-3 font-default">
              7. Third-Party Links
            </h3>
            <p className="text-muted-foreground leading-7 font-default">
              Our service may contain links to other sites that are not operated by us. We strongly advise you to review the Privacy Policy of every site you visit.
            </p>
          </div>

          <hr className="border-border" />

          <div className="border-l-[3px] border-secondary pl-6">
            <h3 className="text-xl font-bold text-foreground mb-3 font-default">
              8. Children's Privacy
            </h3>
            <p className="text-muted-foreground leading-7 font-default">
              Our services are not directed to individuals under the age of 13. We do not knowingly collect personal information from children under 13.
            </p>
          </div>

          <hr className="border-border" />

          <div className="border-l-[3px] border-secondary pl-6">
            <h3 className="text-xl font-bold text-foreground mb-3 font-default">
              9. International Transfers
            </h3>
            <p className="text-muted-foreground leading-7 font-default">
              Your information may be transferred to and maintained on computers located outside of your state or country where data protection laws may differ.
            </p>
          </div>

          <hr className="border-border" />

          <div className="border-l-[3px] border-secondary pl-6">
            <h3 className="text-xl font-bold text-foreground mb-3 font-default">
              10. Data Retention
            </h3>
            <p className="text-muted-foreground leading-7 font-default">
              We will retain your personal information only for as long as is necessary for the purposes set out in this Privacy Policy.
            </p>
          </div>

          <hr className="border-border" />

          <div className="border-l-[3px] border-secondary pl-6">
            <h3 className="text-xl font-bold text-foreground mb-3 font-default">
              11. Changes to This Policy
            </h3>
            <p className="text-muted-foreground leading-7 font-default">
              We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page.
            </p>
          </div>

          <hr className="border-border" />

          <div className="border-l-[3px] border-secondary pl-6">
            <h3 className="text-xl font-bold text-foreground mb-3 font-default">
              12. California Privacy Rights
            </h3>
            <p className="text-muted-foreground leading-7 font-default">
              California residents have specific rights under the CCPA regarding their personal information, including the right to opt-out of the sale of personal data.
            </p>
          </div>

          <hr className="border-border" />

          <div className="border-l-[3px] border-secondary pl-6">
            <h3 className="text-xl font-bold text-foreground mb-3 font-default">
              13. Contact Us
            </h3>
            <p className="text-muted-foreground leading-7 font-default">
              If you have any questions about this Privacy Policy, please contact us using the information provided at the top of this page.
            </p>
          </div>
        </div>
      </div>
    </section>;
}